import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import React from "react";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { AllCoObjectsSelector } from "../../components/generic/AllCoObjectsSelector";
import { ObjectsListUpdatePanel } from "../../components/coobjects/object-list-panel/ObjectsListUpdatePanel";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { NotCompatibleWithWeb } from "../../components/layout/ConfirmationModal";
import { DocumentPartListUpdateFooter } from "../../components/coobjects/object-list-panel/DocumentPartListUpdateFooter";
import { isFeatureActiveOnCurrentClient } from "../../api/config/ExternalConfig";
import { UserFunctionEnum } from "../../api/models/user-function-enum";

export const UpdatesPage: React.FunctionComponent = () => {
  if (!isFeatureActiveOnCurrentClient()) return <NotCompatibleWithWeb />;

  return (
    <ProtectedComponent
      userFunction={UserFunctionEnum.MENU_UPDATE_PANEL_GET_CHANGES}
      protectionType={true}
      errorComponent={<UnauthorizedError />}
    >
      <CoRetrieveDocumentData shouldFetchDocumentPart={true} shouldFetchDocumentPartMetadata={true}>
        {({ coObject, documentPart, documentPartMetadata }) =>
          coObject?.documentId ? (
            <AllCoObjectsSelector>
              {(coObjectsArray, reloadCoObjects) => (
                <ObjectsListUpdatePanel
                  documentPart={documentPart}
                  documentPartMetadata={documentPartMetadata}
                  documentCoObjects={coObjectsArray.filter(
                    (coObject) => coObject.info.objectType === "DOCUMENT_PART_INCLUDE"
                  )}
                  reloadCoObjects={reloadCoObjects}
                  footerComponents={DocumentPartListUpdateFooter}
                  page="updates"
                  key={coObject.documentId}
                />
              )}
            </AllCoObjectsSelector>
          ) : (
            <DocumentNotValidError />
          )
        }
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
